export const createStoreInfoLookup = (storeNames = []) => {
  const lookup = new Map();

  if (!Array.isArray(storeNames)) {
    return lookup;
  }

  storeNames.forEach((store) => {
    if (store && store.id !== undefined && store.id !== null) {
      lookup.set(store.id, store);
    }
  });

  return lookup;
};

const getCompanyName = (storeInfo) => {
  if (!storeInfo) {
    return "Unassigned Company";
  }

  return (
    storeInfo.company_info?.company_name ||
    storeInfo.company_info?.name ||
    "Unassigned Company"
  );
};

export const groupStoreOptionsByCompany = (
  storeOptions = [],
  storeInfoLookup = new Map()
) => {
  if (!Array.isArray(storeOptions)) {
    return [];
  }

  const groups = [];
  const groupMap = new Map();

  storeOptions.forEach((option) => {
    const storeId = option?.store;

    if (storeId === undefined || storeId === null) {
      return;
    }

    const storeInfo = storeInfoLookup.get(storeId);

    if (!storeInfo) {
      return;
    }

    const companyId = storeInfo.company ?? `__no_company_${storeId}`;

    if (!groupMap.has(companyId)) {
      groupMap.set(companyId, {
        companyId,
        companyName: getCompanyName(storeInfo),
        options: [],
      });
      groups.push(groupMap.get(companyId));
    }

    groupMap.get(companyId).options.push(option);
  });

  return groups;
};
